<template>
  <div class="rever-modal-footer">
    <Button
      plain
      class="me-2"
      color="primary"
      :data-testid="cancelTestId"
      :data-tourid="cancelTourId"
      :disabled="disableCancel"
      :text="cancelText"
      @click="$emit('cancel')"
    />

    <Button
      color="primary"
      :data-testid="okTestId"
      :data-tourid="okTourId"
      :disabled="disableOk"
      :text="okText"
      @click="$emit('ok')"
    />
  </div>
</template>

<script>
import Button from '@/components/UI/Button'
export default {
  name: 'ModalFooter',

  components: {
    Button,
  },

  props: {
    cancelTestId: {
      type: String,
      required: false,
    },
    cancelTourId: {
      type: String,
      required: false,
    },
    okTestId: {
      type: String,
      required: false,
    },
    okTourId: {
      type: String,
      required: false,
    },
    cancelText: {
      type: String,
      required: true,
    },
    okText: {
      type: String,
      required: true,
    },
    disableOk: {
      type: Boolean,
      required: false,
      default: false,
    },
    disableCancel: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>
